// extracted by css-extract-rspack-plugin
export default {"modal":"modal-uOCvKA","title":"title-uUEGrN","header":"header-DekDjy","footer":"footer-GtvuKJ"};